const objFromArrayFaq = (arr: any[], key: string = 'faqId') => arr.reduce((accumulator, current) => {
  accumulator[current[key]] = current;
  return accumulator;
}, {});

export default objFromArrayFaq;
